import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as diamondsActionCreators from '../../../actions/diamonds';
let allActionCreators = Object.assign({}, diamondsActionCreators);

class HeaderCalculator extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      size: '',
      shape: 'round',
      color: '',
      clarity: '',

      percentMod: '20.00',

      requestData: null,
      requestPending: false,

      pricePer: '', 

      modeDefault: true,
      targetTotal: '',
    };

    this.totalInput = null;
  }

  componentWillMount() {
    // window.addEventListener('click', this.checkClick, false);
  }

  componentWillUnmount() {
    // window.removeEventListener('click', this.checkClick, false);
  }

  componentWillUpdate(nextProps, nextState) {
    
  }

  getPercentDecimal() {
    try {
      return 1.0 + parseFloat(this.state.percentMod) / 100;
    } catch(err) {
      console.error(err);
      return 1.0;
    }
  }

  getPricePer() {
    if(!this.state.pricePer) {
      return '';
    }
    if(this.state.modeDefault) {
      return Math.round(this.state.pricePer * this.getPercentDecimal());
    } else {
      const percentCalc = this.getCalcPercentage();
      if(!percentCalc) { 
        return Math.round(this.state.pricePer);
      } else {
        const multiplyPercent = parseFloat(percentCalc)/100 + 1;
        return Math.round(this.state.pricePer * multiplyPercent);
      }
    }
  }

  getPriceTotal() {
    if(!this.state.size || !this.state.pricePer) {
      return '';
    }
    return Math.round(parseInt(this.state.pricePer) * parseFloat(this.state.size) * this.getPercentDecimal());
  }

  changeShape(evt) {
    this.setState({
      shape: evt.target.value,
    });
  }

  changeSize(evt) {
    this.setState({
      size: evt.target.value,
    });
  }

  changeColor(evt) {
    this.setState({
      color: evt.target.value,
    });
  }

  changeClarity(evt) {
    this.setState({
      clarity: evt.target.value,
    });
  }

  changePercent(evt) {
    this.setState({
      percentMod: parseFloat(evt.target.value),
    });
  }

  formatPercent() {
    this.setState({
      percentMod: this.state.percentMod.toFixed(2),
    });
  }

  addPercent() {
    if(!this.state.modeDefault) { return null; }
    this.setState({
      percentMod: (parseFloat(this.state.percentMod) + 1).toFixed(2),
    });
  }

  minusPercent() {
    if(!this.state.modeDefault) { return null; }
    this.setState({
      percentMod: (parseFloat(this.state.percentMod) - 1).toFixed(2),
    });
  }

  makeRequest(evt) {

    // validate
    if(!this.state.size || !this.state.shape || !this.state.color || !this.state.clarity) {
      return null;
    }
    
    const diamondObj = {
      size: this.state.size,
      shape: this.state.shape,
      color: this.state.color,
      clarity: this.state.clarity,
    }

    this.setState({
      requestData: null,
      requestPending: true,
      pricePer: '',
    });

    this.props.fetchRapnetPrice(diamondObj)
    .then((respData) => {
      this.setState({
        requestData: respData,
        requestPending: false,
        pricePer: respData && respData.caratprice ? respData.caratprice : '',
      });
    })
    .catch((errorResp) => {
      console.error(errorResp);
      this.setState({
        requestData: null,
        requestPending: false,
        pricePer: '',
      });
    }); 
  }

  setMode(isDefault) {
    this.setState({
      modeDefault: isDefault,
    }, () => {
      if(this.state.modeDefault === false && this.totalInput) {
        this.totalInput.focus();
      }
    });
  }

  changeTargetTotal(evt) {
    this.setState({
      targetTotal: evt.target.value,
    });
  }

  getCalcPercentage() {
    if(this.state.modeDefault || !this.state.targetTotal) { return ''; }
    if(!this.state.size || !this.state.pricePer) { return ''; }

    const rapTotal = parseFloat(parseInt(this.state.pricePer) * parseFloat(this.state.size));
    const inputTotal = parseFloat(this.state.targetTotal);
    
    return ((parseFloat(inputTotal/rapTotal) - 1) * 100).toFixed(2);
  }

  render() {

    return (
      <div className={'HeaderCalculator'}>
        <div className='hcWrapper'>
          <div className='hcTitle'>
            <div className='hcTitleCopy'>Natural Diamonds Calculator</div>
            <div className='hcTitleClose' onClick={this.props.closeCalc.bind(this)}>&times;</div>
          </div>
          <div className='hcControls'>
            <div className={'sizeWrapper controlWrapper'}>
              <div className='controlLabel'>Size</div>
              <div className='controlInputWrapper'>
                <input 
                  type='number' 
                  min='0' 
                  max='20' 
                  step='0.01'
                  value={this.state.size}
                  onChange={this.changeSize.bind(this)} />
              </div>
            </div>
            <div className={'shapeWrapper controlWrapper'}>
              <div className='controlLabel'>Shape</div>
              <div className='controlInputWrapper'>
                <select value={this.state.shape} onChange={this.changeShape.bind(this)}>
                  <option value='round'>Round</option>
                  <option value='pear'>Oval</option>
                  <option value='pear'>Emerald</option>
                  <option value='pear'>Pear</option>
                  <option value='pear'>Cushion</option>
                  <option value='pear'>Princess</option>
                  <option value='pear'>Radiant</option>
                  <option value='pear'>Marquise</option>
                  <option value='pear'>Ascher</option>
                  <option value='pear'>Heart</option>
                </select>
              </div>
            </div>
            <div className={'colorWrapper controlWrapper'}>
              <div className='controlLabel'>Color</div>
              <div className='controlInputWrapper'>
                <select value={this.state.color} onChange={this.changeColor.bind(this)}>
                  <option value=''></option>
                  <option value='D'>D</option>
                  <option value='E'>E</option>
                  <option value='F'>F</option>
                  <option value='G'>G</option>
                  <option value='H'>H</option>
                  <option value='I'>I</option>
                  <option value='J'>J</option>
                  <option value='K'>K</option>
                  <option value='L'>L</option>
                  <option value='M'>M</option>                  
                </select>
              </div>
            </div>
            <div className={'clarityWrapper controlWrapper'}>
              <div className='controlLabel'>Clarity</div>
              <div className='controlInputWrapper'>
                <select value={this.state.clarity} onChange={this.changeClarity.bind(this)}>
                  <option value=''></option>
                  <option value='IF'>IF</option>
                  <option value='VVS1'>VVS1</option>
                  <option value='VVS2'>VVS2</option>
                  <option value='VS1'>VS1</option>
                  <option value='VS2'>VS2</option>
                  <option value='SI1'>SI1</option>
                  <option value='SI2'>SI2</option>
                  <option value='I1'>I1</option>                  
                </select>
              </div>
            </div>
          </div>
          <div className='hcOutput'>
            {this.state.modeDefault ?
              <div className='outputWrapper'>
                <div className='outputTitle'>$ / Carat</div>
                <div className='outputField'>{this.getPricePer()}</div>
                <div className='outputTitle'>$ Total</div>
                <div className='outputField'>{this.getPriceTotal()}</div>
              </div> : 
              <div className='outputWrapper'>
                <div className='outputTitle'>$ / Carat</div>
                <div className='outputField'>{this.getPricePer()}</div>
                <div className='outputTitle'>$ Total</div>
                <div className='outputField'>
                  <input 
                    type='number'
                    step={1}
                    value={this.state.targetTotal}
                    onChange={this.changeTargetTotal.bind(this)}
                    ref={(totalInput) => { this.totalInput = totalInput; }} />
                </div>
              </div>
            }
            <div className='percentWrapper'>
              <div className='outputTitle'>Rap %</div>
              <div className={this.state.modeDefault ? 'percentUp' : 'percentUp fixed'} onClick={this.addPercent.bind(this)}>
                <div className='percentValue'>+</div>
              </div>
              <div className='percentInputWrapper'>
                {this.state.modeDefault ?
                  <input 
                    type='number' 
                    min='-50' 
                    max='50' 
                    step='0.01'
                    value={this.state.percentMod}
                    onChange={this.changePercent.bind(this)}
                    onBlur={this.formatPercent.bind(this)} /> :
                  <div className='percentOutput'>
                    <div className='percentOutputWrapper'>{this.getCalcPercentage()}</div>
                  </div>
                }
              </div>
              <div className={this.state.modeDefault ? 'percentDown' : 'percentDown fixed'} onClick={this.minusPercent.bind(this)}>
                <div>-</div>
              </div>
            </div>
          </div>
          <div className='hcModeToggle'>
            <div className='hcModeToggleLiner'>
              <div className={this.state.modeDefault ? 'hcModeButton selected' : 'hcModeButton'} onClick={() => this.setMode(true)}>
                <div>Calculate Total</div>
              </div>
              <div className={!this.state.modeDefault ? 'hcModeButton selected' : 'hcModeButton'} onClick={() => this.setMode(false)}>
                <div>Calculate Percent</div>
              </div>
            </div>
          </div>
          <div className='hcAction'>
            <button 
              type='button' 
              className={'calcSubmit actionButton'}
              disabled={this.state.requestPending}
              onClick={this.makeRequest.bind(this)}>Calculate</button>
          </div>
        </div>
      </div>
    );
  }
}
export default HeaderCalculator;


function mapStateToProps(state) {
  return {

  };
}

export const HeaderCalculatorContainer = connect(
  mapStateToProps,
  allActionCreators
)(HeaderCalculator);